import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { ICommAutoPolicyChange } from "./commAutoPolicyChangeReq.types";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { ERROR_MESSAGES } from "../../../constants/enums";
import { makeApiCall } from "../../../helpers/postRequest";
import { IDatatableV2AdvancedSearchFilter } from "../../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { IDataTableV2DateState } from "../../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { uploadTaskFile } from "../../tasks/tasksActions";
import { IInternalLogEntry } from "../../accessLogs/accessLogs.types";
import {
  EDIT_POLICY_CHANGE_REQUEST_V2,
  EDIT_PUBLIC_POLICY_CHANGE_REQUEST_V2,
  GET_POLICY_CHANGE_REQUEST_V2,
  POLICY_CHANGE_V2_GET_TYPE,
  POLICY_CHANGE_V2_TYPE,
  buildPolicyChangeV2Query,
  omitPolicyChangeV2Fields,
} from "../../../constants/policyChangeV2.constants";

export const FETCH_COMM_AUTO_POLICY_CHANGE_LIST_PROGRESS =
  "FETCH_COMM_AUTO_POLICY_CHANGE_LIST_PROGRESS";
export const FETCH_COMM_AUTO_POLICY_CHANGE_LIST_SUCCESS =
  "FETCH_COMM_AUTO_POLICY_CHANGE_LIST_SUCCESS";
export const FETCH_COMM_AUTO_POLICY_CHANGE_LIST_FAILED =
  "FETCH_COMM_AUTO_POLICY_CHANGE_LIST_FAILED";

export const fetchCommAutoPolicyListProgress = () =>
  action(FETCH_COMM_AUTO_POLICY_CHANGE_LIST_PROGRESS);
export const fetchCommAutoPolicyListSuccess = (
  list: ICommAutoPolicyChange[],
  totalRecords: number
) =>
  action(FETCH_COMM_AUTO_POLICY_CHANGE_LIST_SUCCESS, {
    list,
    totalRecords,
  });
export const fetchCommAutoPolicyListFailed = () =>
  action(FETCH_COMM_AUTO_POLICY_CHANGE_LIST_FAILED);

export const  fetchCommAutoPolicyListAsync =
  (
    customerpolicyId: number,
    status: string,
    searchValue: IDatatableV2AdvancedSearchFilter,
    date: IDataTableV2DateState["dates"],
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchCommAutoPolicyListProgress());
      let finalUrl =
        GET_POLICY_CHANGE_REQUEST_V2 +
        buildPolicyChangeV2Query({
          policy_type: POLICY_CHANGE_V2_GET_TYPE.COMMAUTO,
          customer_policy_id: customerpolicyId,
          from_date: date.fromDate,
          to_date: date.toDate,
        });

      if (status !== undefined && status !== "-1") {
        finalUrl += "&status=" + status;
      }
      if (searchValue.length > 0) {
        finalUrl += `&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      const res = await api.get(finalUrl);
      const data: ICommAutoPolicyChange[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchCommAutoPolicyListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchCommAutoPolicyListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_PROGRESS =
  "FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_PROGRESS";
export const FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_SUCCESSS =
  "FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_SUCCESSS";
export const FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_FAILED =
  "FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_FAILED";

export const fetchCommAutoPolicyChangeProgress = () =>
  action(FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_PROGRESS);
export const fetchCommAutoPolicyChangeSuccess = (data: ICommAutoPolicyChange) =>
  action(FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_SUCCESSS, { data });
export const fetchCommAutoPolicyChangeFailed = (error?: string) =>
  action(FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_FAILED, { error });

export const fetchCommAutoPolicyChangeAsync =
  (
    customerPolicyId: number,
    incrementalNumber: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchCommAutoPolicyChangeProgress());
      const res = await api.get(
        `/policy/get-policy-commauto-policy-change-request?customer_policy_id=${customerPolicyId}&change_request_code=${incrementalNumber}`
      );
      const data = res.data.data;
      if (data.length > 0) {
        dispatch(fetchCommAutoPolicyChangeSuccess({ ...data[0] }));
      } else {
        dispatch(
          fetchCommAutoPolicyChangeFailed(ERROR_MESSAGES.NO_RECORD_FOUND)
        );
      }
    } catch (err: any) {
      dispatch(fetchCommAutoPolicyChangeFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const upsertCommAutoPolicyChange =
  (
    data: ICommAutoPolicyChange,
      initialData: ICommAutoPolicyChange,
            isUpdate: boolean,
    onCallback: (isSuccess: boolean, data?: ICommAutoPolicyChange) => void,
    logData?: IInternalLogEntry,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const asPayload = {
        customer_id: data.customer_id,
        policy_type: data.policy_type,
        customer_policy_id: data.customer_policy_id,
        page_name: "Automobile Policy Change",
      };

      const updateFilesJson = await uploadTaskFile(
        data.attachments as any,
        "POLICY",
        asPayload
      );


         const res = await makeApiCall(
                    {
                      url:  "/policy/edit-policy-commauto-policy-change-request",
                      method: "POST",
                      automation: {
                        isUpdate: isUpdate,
                        primaryFieldName: "change_request_code",
                      },
                    },
                    initialData,
                    {
                      ...data,
                      attachments: updateFilesJson,
                    }
                  );

      onCallback(true, res.data.data);
      dispatch(
        showMessage({
          type: "success",
          message: "Policy Changed successfully!",
          displayAs: "snackbar",
        })
      );
      dispatch(fetchCommAutoPolicyChangeSuccess(data));
      if (logData) {
        dispatch({ type: "custom/log", logData });
      }
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

// ---------------------------------------------------------------------------
// V2 thunks — mirror the Automobile V2 flow. These use the consolidated
// policy-change endpoints (discriminated by policy_type = COMMAUTO) and the
// omitPolicyChangeV2Fields helper, keeping the legacy per-type thunks above
// untouched. Both reuse the existing FETCH_COMM_AUTO_POLICY_CHANGE_APPLICATION_*
// action/reducer flow so the slice needs no changes.
// ---------------------------------------------------------------------------

export const fetchCommAutoPolicyChangeReqV2Async =
  (
    customerPolicyId: number,
    incrementalNumber: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchCommAutoPolicyChangeProgress());
      const finalUrl =
        GET_POLICY_CHANGE_REQUEST_V2 +
        buildPolicyChangeV2Query({
          policy_type: POLICY_CHANGE_V2_GET_TYPE.COMMAUTO,
          customer_policy_id: customerPolicyId,
          change_request_code: incrementalNumber,
          limit: 1,
        });
      const res = await api.get(finalUrl);
      const data = res.data.data;
      if (data.length > 0) {
        dispatch(fetchCommAutoPolicyChangeSuccess({ ...data[0] }));
      } else {
        dispatch(
          fetchCommAutoPolicyChangeFailed(ERROR_MESSAGES.NO_RECORD_FOUND)
        );
      }
    } catch (err: any) {
      dispatch(fetchCommAutoPolicyChangeFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addCommAutoPolicyChangeV2 =
  (
    data: ICommAutoPolicyChange,
    initialData: ICommAutoPolicyChange,
    isUpdate: boolean,
    onCallback: (isSuccess: boolean, data?: ICommAutoPolicyChange) => void,
    logData?: IInternalLogEntry,
    isPublic?: boolean
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const asPayload = {
        customer_id: data.customer_id,
        policy_type: data.policy_type,
        customer_policy_id: data.customer_policy_id,
        page_name: "Commercial Auto Policy Change",
      };

      const updateFilesJson = await uploadTaskFile(
        data.attachments as any,
        "POLICY",
        asPayload
      );

      const res = await makeApiCall(
        {
          url: isPublic
            ? EDIT_PUBLIC_POLICY_CHANGE_REQUEST_V2
            : EDIT_POLICY_CHANGE_REQUEST_V2,
          method: "POST",
          automation: {
            isUpdate: isUpdate,
            primaryFieldName: "change_request_code",
          },
        },
        omitPolicyChangeV2Fields(initialData),
        {
          ...omitPolicyChangeV2Fields(data),
          policy_type: POLICY_CHANGE_V2_TYPE.COMMAUTO,
          attachments: updateFilesJson,
        },
        isPublic
      );

      onCallback(true, res.data.data);
      dispatch(
        showMessage({
          type: "success",
          message: "Policy Changed successfully!",
          displayAs: "snackbar",
        })
      );
      dispatch(fetchCommAutoPolicyChangeSuccess(data));
      if (logData) {
        dispatch({ type: "custom/log", logData });
      }
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_COMM_AUTO_POLICY_APPLICATION_STATE =
  "CLEAR_COMM_AUTO_POLICY_APPLICATION_STATE";

export const clearCommAutoPolicyState = () =>
  action(CLEAR_COMM_AUTO_POLICY_APPLICATION_STATE);
